import { render, staticRenderFns } from "./StatCard1.vue?vue&type=template&id=0e746679&scoped=true"
import script from "./StatCard1.vue?vue&type=script&lang=js"
export * from "./StatCard1.vue?vue&type=script&lang=js"
import style0 from "./StatCard1.vue?vue&type=style&index=0&id=0e746679&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e746679",
  null
  
)

export default component.exports